var mods = require('./mods')
module.exports = {

    wxPay: function (pay_info, callback) {
        self = this;

        if (typeof WeixinJSBridge !== "undefined") {
            WeixinJSBridge.invoke(
                'getBrandWCPayRequest', {
                   "appId": pay_info.appId,     //公众号名称，由商户传入     
                   "timeStamp": pay_info.timeStamp,         //时间戳，自1970年以来的秒数     
                   "nonceStr": pay_info.nonceStr, //随机串     
                   "package": pay_info.package,     
                   "signType": pay_info.signType,         //微信签名方式：     
                   "paySign": pay_info.paySign //微信签名 
                },
                function(res){
                    window.alert(JSON.stringify(res))
                    if (res.err_msg == "get_brand_wcpay_request:ok" ) {
                        // 使用以上方式判断前端返回,微信团队郑重提示：
                        //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                        mods.payResult.succeeded.result_info = res
                        callback(mods.payResult.succeeded)
                    }else if (res.err_msg == "get_brand_wcpay_request:cancel" ) {
                        mods.payResult.cancel.result_info = res
                        callback(mods.payResult.cancel)
                    }else{
                        mods.payResult.failed.result_info = res
                        callback(mods.payResult.failed)
                    }
             });
        }else if (typeof wx !== "undefined") {
            window.alert(JSON.stringify(res))
            wx.chooseWXPay({
                timestamp: pay_info.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                nonceStr: pay_info.nonceStr, // 支付签名随机串，不长于 32 位
                package: pay_info.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                signType: pay_info.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                paySign: pay_info.paySign, // 支付签名
                success: function (res) {
                    // 支付成功后的回调函数
                    mods.payResult.succeeded.result_info = res
                    callback(mods.payResult.succeeded)
                },
                cancel: function(res) {
                    // 支付取消
                    mods.payResult.cancel.result_info = res
                    callback(mods.payResult.cancel)
                },
                fail: function(res) {
                    // 支付失败
                    mods.payResult.failed.result_info = res
                    callback(mods.payResult.failed)
                }
            });
        }else{
            self.loadWXPay().then(res => {
                if (res) {
                    self.wxPay(pay_info)
                }
            }).catch(err => {
                console.error(err)
            })
        }
    },
    // 初始化wx对象
    loadWXPay: function () {
        return new Promise((resolve, reject) => {
            let script = document.createElement("script");
            script.type = "text/javascript";
            script.src = "https://res.wx.qq.com/open/js/jweixin-1.4.0.js";
            script.onload = () => {
                resolve(true)
            }
            script.onerror = reject;
            document.head.appendChild(script);
        })
    },
};
  


// WEBPACK FOOTER //
// ./src/wxPay.js